const COUNTRY_INDEX = 1;

export const formatDestination = (destination: string | null): string | null => {
    if (destination == null) {
        return null;
    }

    const destinationParts = destination.split(';');
    const lastDestinationPart = destinationParts.length > 2 ? destinationParts[destinationParts.length - 1] : null;

    return destinationParts[COUNTRY_INDEX] + (lastDestinationPart ? `, ${lastDestinationPart}` : '');
};
